import { FC } from 'react'
import { isMobile } from 'react-device-detect'
import { Box } from '../../../UI'
import useStyles from './styles'
import { TemplateProps } from './types'

const Template: FC<TemplateProps> = ({
  id = '', children,
  relativeStyle = {}, absoluteStyle = {},
  relativeClass = '', absoluteClass = ''
}) => {
  const classes = useStyles()

  return (
    <Box
      id={id}
      className={`${classes.relative} ${relativeClass} ${isMobile ? classes.hideScrollbar : ''}`}
      style={relativeStyle}
    >
      <Box className={`${classes.absolute} ${absoluteClass}`} style={absoluteStyle}>
        {children}
      </Box>
    </Box>
  )
}
export default Template
